import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { ClientService } from '../../../services/client.service';
import { TypeClientSearch } from '../../../models/search-client.model';
import { PetAssociateModel } from '../../../models/pet-associate.model';
import { ClientSearchResultsModel } from '../../../models/search-client.model';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-associate',
  templateUrl: './associate.component.html',
})
export class AssociateComponent implements OnInit {

  private _pet_no: number;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getAssociateByPetId(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    public clientService: ClientService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
    });

    this.petService.getAssociateByPetId(this.petService.current_pet_no).then(() => { });

    this.clientService.selectedClient
      .subscribe(message => {
        if (Number(message.client_no) > 0) {
          this.petService.pet_associate = new PetAssociateModel(0, '', message.client_name, '', Number(message.client_no), 0, '', 0);
          //$('#modalAssociatePet').modal('toggle')
        }
      });

  }

  add() {
    this.clientService.clients = [];
    this.clientService.search.page_number = 1;
    this.clientService.search.type = TypeClientSearch.SELECT; 
    this.petService.op_type = 0;
    $('#modalSearchClient').modal('toggle')
  }

  edit(item) {
    //this.petService.pet_associate = item;
    this.clientService.selected_client = new ClientSearchResultsModel(0,'', '', '','','','','');
    this.petService.op_type = 1;
    $('#modalAssociatePet').modal('toggle')
  }

  trash(item) {
    Swal.fire({
      text: "Are you sure to delete it?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.petService.pet_associate = item;

        Swal.fire({
          title: 'Loading...',
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
          },
        })

        this.petService.deletePetAssociate()
          .then(() => {
            this.petService.getAssociateByPetId(this.petService.current_pet_no)
              .then(() => {
                this.petService.pet_associate = new PetAssociateModel(0, '', '', '', 0, 0, '', 0);
                Swal.close();
              });
          });
      }
    })
  }
}
